import TabSwitcher, { type TabOption } from 'components/TabSwitcher';
import { ClubTab } from './types';

const OPTIONS: TabOption<ClubTab>[] = [
  { label: 'Courts', value: 'COURTS', iconSrc: '/images/app/court-3d.svg' },
  { label: 'Events', value: 'EVENTS', iconSrc: '/images/app/all-sports.svg' },
  {
    label: 'Club info',
    value: 'INFO',
    iconSrc: '/images/player-home-v2/discover/search-colored.png',
  },
];

interface Props {
  selectedTab: ClubTab;
  onTabChange: (tab: ClubTab) => void;
}

/**
 * Mobile-only section switcher for the club page. Desktop lays the same three
 * areas out side by side, so it never renders this.
 */
export default function ClubTabs({ selectedTab, onTabChange }: Props) {
  return (
    <TabSwitcher
      keepIconColor
      options={OPTIONS}
      selectedValue={selectedTab}
      onValueChange={onTabChange}
      wrapperClassName="lg:hidden"
    />
  );
}
